module.exports = __webpack_public_path__ + "img/home3.16eab324.png";